import React from "react";
import ChangeBar from "./BrowserTable/ChangeBar";
import CountBar from "./BrowserTable/CountBar";

export const BrowserTableConfig = [
    {
        text: "Rank",
        component: ({ row }) => row.rank,
        sortable: false,
        width: "5"
    },
    {
        text: "Company(Ticker)",
        field: "",
        component: ({ row }) => row.company.length === 0 ? row.ticker : `${row.company} (${row.ticker})`,
        sortable: false,
        width: "30"
    },
    {
        text: "Total Mentions",
        sortable: true,
        field: "mentions",
        component: ({ row }) => { return <CountBar data={row["mentions"]} /> },
        width: "20"
    },
    {
        text: "Sentiment",
        sortable: true,
        field: "sentiment",
        component: ({ row, sentimentPositiveRatio }) => { return <ChangeBar positiveRatio={sentimentPositiveRatio} data={row["sentiment"]} /> },
        width: "20"
    },
    {
        text: "Change in Mentions",
        sortable: true,
        field: "mentionsChange",
        component: ({ row, mentionsChangePositiveRatio }) => { return <ChangeBar positiveRatio={mentionsChangePositiveRatio} data={row["mentionsChange"]} /> },
        width: "20"
    },
]